// File: src/components/Answer/AnswerIcon.tsx

import React from "react";

export const AnswerIcon: React.FC = () => {
    return (
        <div
            style={{
                width: "28px",
                height: "28px",
                background: "#40424a",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "14px",
                fontWeight: "500",
                color: "#ffffff",
                flexShrink: "0"
            }}
        >
            C
        </div>
    );
};
